import { CLEAR_ULT_PAYMENT } from '../constants'

export function reducer(state, action) {
    if (action.type === CLEAR_ULT_PAYMENT) {
        return {
            ...state,
            urlAddPyment: false,
            urlPaymentsAdministrator: false,
            urlContinuePayment: false
        }
    } else {
        return state
    }
}
